export default __webpack_public_path__ + "static/media/Resume-Pawnpunnarai-Sai-Senior-Developer.docx.1212ea97.pdf";